import { defineComponent as _defineComponent } from 'vue'
import {
  computed, PropType, ref, toRefs, watch
} from 'vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import { useStore } from 'vue2-helpers/vuex';
import { whenever } from '@vueuse/core';
import useResponsiveness from '@/mixins/useResponsiveness';
import useUser from '@/mixins/useUser';
import useI18n from '@/mixins/useI18n';
import useProjectGuestState from '@/state/projectGuestState';
import ThreadEntry from './ThreadEntry.vue';
import CreateMessage from './CreateMessage.vue';
import { Message, MessagePost } from '../models/Forum';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThreadReply',
  props: {
  reply: {
    type: Object as PropType<Message>,
    default: null
  },
  threadId: {
    type: String,
    default: undefined
  },
  disableReply: {
    type: Boolean,
    default: false
  },
  groupId: {
    type: String,
    default: undefined
  },
  forumId: {
    type: String,
    default: undefined
  },
  editMessageId: {
    type: String,
    default: ''
  }
},
  emits: ['edit-message', 'post-message', 'update-message'],
  setup(__props, { emit }) {

const props = __props;

const SLOW_CONNECTION_TIMEOUT = 1000; // ms





const store = useStore();
const { t } = useI18n();
const { isMobileLayout } = useResponsiveness();
const user = useUser('self');
const { projectGuestList } = useProjectGuestState(store.state.project?.company?.id);

const isUpdatingMessage = computed(() => store.state.forum.isUpdatingMessage);
const currentMessageUpdating = ref(false);
const {
  reply, editMessageId, threadId, forumId
} = toRefs(props);
const editMessageVisible = computed({
  get: () => editMessageId.value === reply.value.messageId,
  set: (value: boolean) => {
    emit('edit-message', value ? props.reply.messageId : '');
  }
});

const messageRecentlyUpdated = ref(false);

watch(
  () => isUpdatingMessage.value,
  (value) => {
    if (value) {
      setTimeout(() => {
        if (messageRecentlyUpdated.value && isUpdatingMessage.value) {
          currentMessageUpdating.value = true;
        }
      }, SLOW_CONNECTION_TIMEOUT);
    } else {
      currentMessageUpdating.value = false;
    }
  }
);

whenever(
  () => messageRecentlyUpdated.value && editMessageId.value.length > 0,
  () => {
    messageRecentlyUpdated.value = false;
  }
);

const toggleEditMessage = () => {
  emit('edit-message', reply.value.messageId);
};

const postMessage = (postMessage: MessagePost) => {
  emit('post-message', postMessage);
};

const postMessageEdit = (text: string) => {
  const postMessage = {
    forumId: forumId.value,
    threadId: threadId.value,
    forumThreadMessageId: reply.value.messageId,
    messageContent: text
  };
  emit('update-message', postMessage, props.reply.messageCount);
  messageRecentlyUpdated.value = true;
  toggleEditMessage();
};

const createMessagePlaceHolder = computed(() => {
  if (!store.state.projectForum.project.id.length) {
    return '';
  }
  if (user.userId.value === store.state.projectForum.project.creator.userId || projectGuestList.value.map((guest) => guest.id).includes(user.userId.value)) {
    return t('project-forum.placeholder.project-answer-op');
  }
  return t('project-forum.placeholder.project-answer-user');
});

return { __sfc: true,SLOW_CONNECTION_TIMEOUT, props, emit, store, t, isMobileLayout, user, projectGuestList, isUpdatingMessage, currentMessageUpdating, reply, editMessageId, threadId, forumId, editMessageVisible, messageRecentlyUpdated, toggleEditMessage, postMessage, postMessageEdit, createMessagePlaceHolder, BCXMarkdown, ThreadEntry, CreateMessage }
}

})